import { render, staticRenderFns } from "./lamsAuthBaseCategoryApproval.vue?vue&type=template&id=e1cb78e4&scoped=true&"
import script from "./lamsAuthBaseCategoryApproval.vue?vue&type=script&lang=js&"
export * from "./lamsAuthBaseCategoryApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cb78e4",
  null
  
)

export default component.exports